import { httpCreate } from './http';

const http = httpCreate('/srv/accessNotice');

export const accessNotice = {
	getConfig(activityId) {
		return http.get(`/${activityId}`);
	},
	setConfig(activityId, body) {
		return http.post(`/save/${activityId}`, body);
	},
};
